const productTile = () => {
    const classes = {
        productTileLoading: 'product-tile--loading',
        productTileQuickAddLoading: 'product-tile__quick-add-loading',
        swatchActive: 'product-tile__swatch--active',
    };
    const selectors = {
        productTileMainImage: '.image__main',
        // Main Tile
        productTileVariantIdAttr: 'data-product-variant-id',
        // Swatches
        productTileSwatch: '[data-product-tile-swatch]',
        productTileSwatchImage: 'data-product-tile-swatch-image',
        productTileSwatchImageSrcset: 'data-product-tile-swatch-image-srcset',
        productTileSwatchVariantID: 'data-product-tile-swatch-variant-id',
        productTileSwatchVariantURL: 'data-product-tile-swatch-variant-url',
        productTileSwatchVariantAvailability: 'data-product-tile-swatch-variant-availability',
        // Quick Add
        productTileQuickAddButton: '[data-product-tile-quick-add]',
        productTileQuickAddVariantID: 'data-product-tile-quick-add-variant-id',
    };
    const events = ['load', 'frank-green:product-tiles-loaded'];
    events.forEach((event) => {
        window.addEventListener(event, () => {
            const productTiles = document.querySelectorAll('[data-product-tile]');
            productTiles.forEach((tile) => {
                const video = tile.querySelector('.image__hover video');
                const swatches = tile.querySelectorAll(selectors.productTileSwatch);
                const quickAddButton = tile.querySelector(selectors.productTileQuickAddButton);
                if (video) {
                    video.pause();
                    tile.addEventListener('mouseover', () => {
                        video.play();
                    });
                    tile.addEventListener('mouseout', () => {
                        video.pause();
                    });
                }
                if (swatches) {
                    swatches.forEach((swatch) => {
                        // Swatches
                        const tileImageContainer = tile.querySelector(selectors.productTileMainImage);
                        const imageURL = swatch.getAttribute(selectors.productTileSwatchImage);
                        const imageSRCSET = swatch.getAttribute(selectors.productTileSwatchImageSrcset);
                        // Links
                        const variantURL = swatch.getAttribute(selectors.productTileSwatchVariantURL);
                        // QuickAdd
                        const variantID = swatch.getAttribute(selectors.productTileSwatchVariantID);
                        const variantAvailable = swatch.getAttribute(selectors.productTileSwatchVariantAvailability);
                        const updateTileVariant = (swatch) => {
                            // Update Variant ID - to show / hide variant badges
                            tile.setAttribute(selectors.productTileVariantIdAttr, variantID);
                            // Images
                            if (tileImageContainer && imageURL && imageSRCSET) {
                                swatches.forEach((otherSwatch) => {
                                    otherSwatch.classList.remove(classes.swatchActive);
                                });
                                swatch.classList.add(classes.swatchActive);
                                tile.classList.add(classes.productTileLoading);
                                const img = document.createElement('img');
                                img.src = imageURL;
                                img.srcset = imageSRCSET;
                                img.onload = () => {
                                    tileImageContainer.innerHTML = '';
                                    tileImageContainer.appendChild(img);
                                    tile.classList.remove(classes.productTileLoading);
                                };
                            }
                            // Links
                            if (variantURL) {
                                const aHrefs = tile.querySelectorAll('a[href]');
                                aHrefs.forEach((href) => {
                                    href.setAttribute('href', variantURL);
                                });
                            }
                            // Update Quik Add
                            if (quickAddButton && variantID) {
                                quickAddButton.setAttribute(selectors.productTileQuickAddVariantID, variantID);
                                if (variantAvailable == 'true') {
                                    quickAddButton.removeAttribute('disabled');
                                }
                                else {
                                    quickAddButton.setAttribute('disabled', 'disabled');
                                }
                            }
                        };
                        swatch.removeEventListener('click', () => {
                            updateTileVariant(swatch);
                        });
                        swatch.addEventListener('click', () => {
                            updateTileVariant(swatch);
                        });
                    });
                }
                if (quickAddButton) {
                    const addItem = () => {
                        const variantID = quickAddButton.getAttribute(selectors.productTileQuickAddVariantID);
                        const formData = {
                            items: [
                                {
                                    id: variantID,
                                    quantity: 1,
                                },
                            ],
                        };
                        fetch(window.Shopify.routes.root + 'cart/add.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(formData),
                        })
                            .then((response) => {
                            if (!response.ok) {
                                if (response.status === 422) {
                                    throw new Error('Validation error: Unable to add item to cart.');
                                }
                                throw new Error('Network response was not ok: ' + response.statusText);
                            }
                            window.dispatchEvent(new CustomEvent('frank-green:quick-add-update'));
                        })
                            .then(() => {
                            const cartToggle = document.querySelector('#cart-icon-bubble');
                            cartToggle?.click();
                            tile.querySelector('[data-product-tile-quick-add]').classList.remove(classes.productTileQuickAddLoading);
                        })
                            .catch((error) => {
                            console.error('Error:', error);
                        });
                    };
                    quickAddButton.removeEventListener('click', addItem);
                    quickAddButton.addEventListener('click', function (event) {
                        event.preventDefault();
                        event.stopPropagation();
                        if (event.currentTarget.classList.contains('disabled'))
                            return;
                        event.currentTarget.classList.add(classes.productTileQuickAddLoading);
                        addItem();
                    });
                }
            });
        });
    });
};
export { productTile };
